<template>
    <div class="tryOnBox">
        <div class="changeClothBtn">
            <div :class="clothesAct == item.id ? 'changeItem changeItemAct' : 'changeItem'" v-for="item in changeBtnlist"
                :key="item.id" @click="changeClose(item)">{{ item.name }}</div>
        </div>
        <div class="scrollable-content">
            <div class="describe">
                <div class="refer_title">
                    <div></div>
                    上传模特图（必填）
                </div>
                <div class="Reference_image">
                    <el-upload class="upload-demo" drag :action="fileApi + '/api/front/upload/?fdir=mj_tool'"
                        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                        accept="image/jpeg, image/png, image/bmp" multiple>
                        <div v-if="form.data.iw_url" class="yesUpload">
                            <img :src="form.data.iw_url" alt="" class="yesUpload_img">
                            <div class="yesUpload_icon" @click.stop="form.data.iw_url = ''">
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                        <div v-else class="noUpload">
                            <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                            <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                            <div> 只能上传jpg/png文件，且不超过10MB</div>
                        </div>
                    </el-upload>
                </div>

                <div class="modelList">
                    <div class="mlistTit">没有图片? 试试以下图片</div>
                    <div class="mlistImgBox">
                        <div class="mlistImgItem" :style="{ backgroundImage: `url(${modeItem.url}` }"
                            v-for="modeItem in modelList" :key="modeItem.id" @click="selectModel(modeItem, 1)"></div>
                        <!-- <img class="mlistImgItem" :src="modeItem.url" alt="" v-for="modeItem in modelList"> -->
                    </div>
                </div>
            </div>
            <div class="describe">
                <div class="refer_title">
                    <div></div>
                    上传衣装图（必填）
                </div>
                <div class="Reference_image">
                    <el-upload class="upload-demo" drag :action="fileApi + '/api/front/upload/?fdir=mj_tool'"
                        :show-file-list="false" :on-success="handleYiSuccess" :before-upload="beforeYiUpload"
                        accept="image/jpeg, image/png, image/bmp" multiple>
                        <div v-if="form.data.iw_urls" class="yesUpload">
                            <img :src="form.data.iw_urls" alt="" class="yesUpload_img">
                            <div class="yesUpload_icon" @click.stop="clearClo">
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                        <div v-else class="noUpload">
                            <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                            <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                            <div> 只能上传jpg/png文件，且不超过10MB</div>
                        </div>
                    </el-upload>
                </div>
                <div class="modelList">
                    <div class="mlistTit">没有图片? 试试以下图片</div>
                    <div class="mlistImgBox">
                        <div class="mlistImgItem" v-show="modeItem.flg == clothesAct"
                            :style="{ backgroundImage: `url(${modeItem.url}` }" v-for="modeItem in clothesList"
                            :key="modeItem.id" @click="selectModel(modeItem, 0)"></div>
                        <!-- <img class="mlistImgItem" :src="modeItem.url" alt="" v-for="modeItem in modelList"> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_area" flex-center>
            <div class="primary_button" @click="sendMsg" v-loading="sending">提交任务 <span>（消耗15积分）</span></div>
        </div>
        <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
export default {
    components: { faceVerifyPopup },
    data() {
        return {
            sending: false,
            originWidth: 0,
            originHeight: 0,
            modelList: [
                {
                    id: 0,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/model2.png'
                },
                {
                    id: 1,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/model1.png'
                },
                {
                    id: 2,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/model3.png'
                }
            ],
            clothesList: [
                {
                    id: 0,
                    flg: 0,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/full1.png'
                },
                {
                    id: 1,
                    flg: 0,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/full2.png'
                },
                {
                    id: 2,
                    flg: 0,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/full3.png'
                },
                {
                    id: 3,
                    flg: 1,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/top1.png'
                },
                {
                    id: 4,
                    flg: 1,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/top2.png'
                },
                {
                    id: 5,
                    flg: 1,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/top3.png'
                },
                {
                    id: 6,
                    flg: 2,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/bottom1.png'
                },
                {
                    id: 7,
                    flg: 2,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/bottom2.png'
                },
                {
                    id: 8,
                    flg: 2,
                    url: 'https://mjimg2024.oss-cn-beijing.aliyuncs.com/bottom3.png'
                }
            ],
            clothesAct: 0,
            clothesUp: '',
            clothesDown: '',
            clothesAll: '',
            changeBtnlist: [
                {
                    id: 0,
                    name: '连衣裙',
                },
                {
                    id: 1,
                    name: '上装',
                },
                {
                    id: 2,
                    name: '下装',
                }
            ],
            // 参数
            form: {
                data:{
                    iw_url: '',
                    iw_urls: '',
                    clothes_type: 'full_body'
                },
                mj_tool:'imgVirtualTryOn'
            },
            // 上传图片
            fileApi: FILE_API_SERVER,
            magnification: [
                { title: '2倍', num: 2 },
                { title: '3倍', num: 3 },
                { title: '4倍', num: 4 },
            ],

        }
    },
    computed: {
        userInfo() {
        return this.$store.state.userInfo;
        },
        isLogin() {
        return this.$store.state.isLogin;
        },
        tips_list() {
        return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
        }
    },
    methods: {
        checkLogin() {
            // 检查登录状态
            if (!this.isLogin) {
                this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
                confirmButtonText: '立即登录',
                cancelButtonText: '关闭',
                type: 'warning',
                customClass: 'confirm_box'
                }).then(() => {
                this.$store.commit('setUserInfo', null)
                this.$store.commit('setIsLogin', false)

                if (this.isWxEnv) {
                    // 微信环境内
                    window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
                } else {
                    this.$store.commit('setShowLogin', true)
                }
                }).catch(() => {
                });
                return false;
            } else {
                return true;
            }

            },
        //发送消息
        sendMsg() {
            if (!this.checkLogin()) return
            if(!utils.setOptData(this.userInfo,'btn_aitool_create')){
                return
            }
            if (this.sending) {
                this.$message.warning('请等待上次绘图完成')
                return
            }
            if (this.form.data.iw_url === ''||this.form.data.iw_urls=='') {
                this.$message.warning('请上传图片')
                return
            }
            // 同步请求
            this.submitQuestion(this.form);
        },
        submitQuestion(data, parent_msg_code, i) {
            this.sending = true;
            // 提交问题
            data.source = "pc";
            this.$http.post('/front/aimj/mjtools/', data).then((res) => {
                if (res.status == 200) {
                    this.$message({
                        message: '创建任务成功！',
                        type: 'success'
                    });
                    this.getProfile()
                    this.$emit('submitForm', {})
                } else {
                    let message = res.message;
                    if (message == "vip_expire") {
                        // VIP 过期了
                        this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
                            confirmButtonText: '开通会员',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass: 'confirm_box'
                        }).then(() => {
                            console.log('进入会员中心')
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "no_open_vip") {
                        // 未开通 VIP
                        this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
                            confirmButtonText: '开通会员',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass: 'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "no_gift_score") {
                        // 积分不足
                        this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
                            confirmButtonText: '升级套餐',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass: 'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "upgradevip") {
                        // 队列已满
                        this.$confirm(res.data.msg, '提示', {
                            confirmButtonText: '升级套餐',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass: 'confirm_box'
                        }).then(() => {
                            this.$router.push('/mjmember')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "no_face_verify") {
                        // 实名认证
                        this.$refs.faceVerifyPopup.show()
                        return
                    }
                    if (message.indexOf("您提问的内容包含违禁词") > -1) {
                        message = "内容可能违反国家政策，请重新输入";
                    }
                    this.$confirm(message, '提示', {
                        type: 'warning',
                        customClass: 'confirm_box'
                    }).then(() => {
                    })
                }
            }).finally(() => {
                this.sending = false;
            })
        },
        getProfile() {
            this.$http.get(`${MAIN_URLROOT}/api/front/user/profile/`).then(res => {
                if (res.status == '200') {
                this.$store.commit('setUserInfo', res.data)
                this.$store.commit('setIsLogin', true)
                }
            }).finally(() => {
            })
        },
        selectModel(data, type) {
            if (type) {//选择模特
                // utils.resizeImage(data.url).then(base64Image => {
                this.form.data.iw_url = data.url
                // })

            } else {//选择衣服
                // this.form.iw_urls = data.url
                // utils.resizeImage(data.url).then(base64Image => {
                this.form.data.iw_urls = data.url
                // })
                if (this.clothesAct == 0) {//连衣裙
                    this.clothesAll = data.url
                } else if (this.clothesAct == 1) {//上身
                    this.clothesUp = data.url
                } else {//下身
                    this.clothesDown = data.url
                }
                console.log(data);

                // this.loadBefoImg(data)
            }

        },
        clearClo() {
            if (this.clothesAct == 1) {//上装
                this.clothesUp = ''
            } else if (this.clothesAct == 2) {//下装
                this.clothesDown = ''
            } else {//全身
                this.clothesAll = ''
            }
            this.form.data.iw_urls = ''
        },
        changeClose(data) {
            this.clothesAct = data.id
            if (this.clothesAct == 1) {//上装
                this.form.data.clothes_type = "upper_body"
                this.form.data.iw_urls = this.clothesUp ? this.clothesUp : ''
                // const needurl = this.clothesUp?this.clothesUp:''
                // utils.resizeImage(needurl).then(base64Image => {
                // this.form.iw_urls = base64Image
                // this.form.iw_urls = this.clothesUp?this.clothesUp:''
                // })
            } else if (this.clothesAct == 2) {//下装
                this.form.data.clothes_type = "lower_body"
                this.form.data.iw_urls = this.clothesDown ? this.clothesDown : ''
                // const needurl = this.clothesDown?this.clothesDown:''
                // utils.resizeImage(needurl).then(base64Image => {
                // this.form.iw_urls = base64Image
                // this.form.iw_urls = this.clothesUp?this.clothesUp:''
                // })
            } else {//全身
                this.form.data.clothes_type = "full_body "
                this.form.data.iw_urls = this.clothesAll ? this.clothesAll : ''
                // const needurl = this.clothesDown?this.clothesDown:''
                // utils.resizeImage(needurl).then(base64Image => {
                // this.form.iw_urls = base64Image
                // this.form.iw_urls = this.clothesUp?this.clothesUp:''
                // })
            }
        },
        //上传衣服
        handleYiSuccess(res) {
            if (res.data.error !== '') {
                this.$message.error(res.data.error);
                return
            }
            if (this.clothesAct == 1) {//上装
                this.clothesUp = res.data.file_full_url
            } else if (this.clothesAct == 2) {//下装
                this.clothesDown = res.data.file_full_url
            } else {//全身
                this.clothesAll = res.data.file_full_url
            }
            // this.form.iw_urls = res.data.file_full_url;
            // utils.resizeImage(res.data.file_full_url).then(base64Image => {
            this.form.data.iw_urls = res.data.file_full_url
            // this.form.iw_urls = this.clothesUp?this.clothesUp:''
            // })
        },
        beforeYiUpload(file) {
            const isLt3M = file.size / 1024 / 1024 < 3;
            const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = URL.createObjectURL(file);
                img.onload = () => {
                    const { width, height } = img;
                    const isValidResolution = width >= 512 && width <= 4096 && height >= 512 && height <= 4096;

                    if (!isValidType) {
                        this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
                        reject({ isValidType: false });
                        return
                    }

                    if (!isLt3M) {
                        this.$message.error('上传文件大小不能超过 3MB!');
                        reject({ isLt3M: false });
                        return
                    }

                    if (!isValidResolution) {
                        this.$message.error('图片分辨率需大于 512x512 像素且小于 4096x4096像素!');
                        reject({ isValidResolution: false });
                        return
                    }

                    resolve({ isValidType, isLt3M, isValidResolution });
                };
                img.onerror = () => {
                    this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
                    reject({ isImageValid: false });
                };
            });
        },

        // 上传模特
        handleAvatarSuccess(res,) {
            if (res.data.error !== '') {
                this.$message.error(res.data.error);
                return
            }
            this.form.data.iw_url = res.data.file_full_url;
            // utils.resizeImage(res.data.file_full_url).then(base64Image => {
            // this.form.iw_url = base64Image
            // this.$forceUpdate()
            // this.form.iw_urls = this.clothesUp?this.clothesUp:''
            // })

        },
        beforeAvatarUpload(file) {
            const isLt3M = file.size / 1024 / 1024 < 10;
            const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = URL.createObjectURL(file);
                img.onload = () => {
                    const { width, height } = img;
                    const isValidResolution = width >= 512 && width <= 4096 && height >= 512 && height <= 4096;

                    if (!isValidType) {
                        this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
                        reject({ isValidType: false });
                        return
                    }

                    if (!isLt3M) {
                        this.$message.error('上传文件大小不能超过 10MB!');
                        reject({ isLt3M: false });
                        return
                    }

                    if (!isValidResolution) {
                        this.$message.error('图片分辨率需大于 512x512 像素且小于 4096x4096像素!');
                        reject({ isValidResolution: false });
                        return
                    }

                    resolve({ isValidType, isLt3M, isValidResolution });
                };
                img.onerror = () => {
                    this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
                    reject({ isImageValid: false });
                };
            });
        },
    }

}
</script>

<style lang="scss" scoped>
.tryOnBox {
    width: 100%;
    height: 100%;
}

.changeClothBtn {
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(49, 51, 56, 1);
    //   padding: 0 10px;
    //   margin-top: 5px;
    //   border: 1px solid #36373d;
    border-radius: 4px;
    padding: 5px 10px;

    .changeItem {
        height: 100%;
        // background: rgba(88, 101, 242,1);
        padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        color: #fff;
    }

    .changeItemAct {
        background: rgba(88, 101, 242, 1);
    }

}

.scrollable-content {
    width: 100%;
    // overflow-y: auto;
    // height: calc(100% - 60px);
    // height: 100%;
    // margin: 10px 0;
    padding: 0 10px;
    color: #fff;
    margin-bottom: 160px;

    .modelList {
        .mlistTit {
            font-size: 13px;
            color: #959698;
            margin: 10px 0;
        }

        .mlistImgBox {
            height: 80px;
            overflow: hidden;
            display: flex;
            justify-content: space-between;

            .mlistImgItem {
                width: 80px;
                height: 80px;
                background-size: cover;
                background-repeat: no-repeat;
                border-radius: 8px;
                overflow: hidden;
                cursor: pointer;
            }
        }
    }



    .describe {
        width: 100%;

        .refer_title {
            height: 18px;
            margin: 15px 0;
            display: flex;
            align-items: center;
            font-size: 14px;

            div {
                height: 100%;
                border: 2px solid #5865f2;
                border-radius: 2px;
                margin-right: 5px;
            }
        }

        .Reference_image {
            width: 100%;
            height: 140px;
            overflow: hidden;

            .upload-demo {
                height: 100%;
            }

            /deep/ .el-upload-dragger {
                //   width: 280px;
                width: calc(100vw - 20px);
                background-color: #1d2027;
                border-color: #3e4149;
                height: 140px;
            }

            /deep/ .el-upload-dragger:hover {
                border-color: #5865f2;
                height: 140px;
            }

            .noUpload {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: #606266;
            }

            .yesUpload {
                position: relative;

                .yesUpload_img {
                    height: 140px;
                }

                .yesUpload_icon {
                    position: absolute;
                    right: 8px;
                    bottom: 8px;
                    //background-color: aquamarine;
                    // color: #c1bfbb;
                    // font-size: 25px;
                    color: #FFF;
                    font-size: 13px;
                    background-color: #5865f2;
                    padding: 3px 5px;
                    border-radius: 5px;
                }

            }
        }

        .drawingMode {
            display: flex;
            justify-content: space-between;

            .itemMode {
                padding: 10px 25px;
                background-color: #1d2027;
                border-radius: 3px;
                border: 2px solid #5865f200;
                cursor: pointer;
                position: relative;

                .vip {
                    position: absolute;
                    color: #f0b132;
                    font-size: 14px;
                    font-weight: 700;
                    top: -11px;
                    right: 0;
                }
            }

            .mode {
                padding: 10px 25px;
                background-color: #1d2027;
                border-radius: 3px;
                border: 2px solid #5865f2;
                cursor: pointer;
                position: relative;

                .vip {
                    position: absolute;
                    color: #f0b132;
                    font-size: 14px;
                    font-weight: 700;
                    top: -11px;
                    right: 0;
                }
            }
        }

    }
}

.bottom_area {
  //background-color: #2b2d31;
  //height: 90px;
  //width: 100%;
  //padding: 0 30px;
  //position: fixed;
  //bottom: 60px;

  background-color: #2b2d31;
  height: 90px;
  width: 100%;
  padding: 0 30px;

    .primary_button {
        font-size: 16px;
        height: 46px;
        padding-top: 13px;
        padding-bottom: 13px;
        border-radius: 9999px;
        flex: 1 1 0%;

        span {
            font-size: 12px;
        }
    }
}
</style>